// Product cards rendered by Liquid (snippets/product-card.liquid): quick add with the size sheet,
// the home page pack finder (tabs filter the rendered cards by collection) and the restock card.
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const strings = window.MP?.strings || {};

  // Quick add: sized packs open the size sheet on the card, single-variant packs go straight in.
  const closeSheet = (article, restoreFocus) => {
    const sheet = article?.querySelector('.shop-card-sizes');
    if (!sheet || !article.classList.contains('is-choosing')) return;
    article.classList.remove('is-choosing');
    sheet.inert = true;
    article.querySelector('.shop-card-add').setAttribute('aria-expanded', 'false');
    if (restoreFocus) article.querySelector('.shop-card-add').focus({ preventScroll: true });
  };
  const openSheet = article => {
    document.querySelectorAll('.shop-card.is-choosing').forEach(other => closeSheet(other));
    const sheet = article.querySelector('.shop-card-sizes');
    article.classList.add('is-choosing');
    sheet.inert = false;
    article.querySelector('.shop-card-add').setAttribute('aria-expanded', 'true');
    sheet.querySelector('[data-size]:not(:disabled)')?.focus({ preventScroll: true });
  };
  const addToCart = (article, variant, size) => {
    const button = article.querySelector('.shop-card-add');
    const label = button.querySelector('span');
    closeSheet(article);
    button.style.minWidth = `${button.offsetWidth}px`;
    button.disabled = true;
    button.classList.add('is-busy');
    const reset = () => {
      button.classList.remove('is-busy', 'is-added');
      button.disabled = false;
      label.textContent = strings.addToCart || label.textContent;
      button.style.minWidth = '';
    };
    window.mpCart.addWithFeedback({
      payload: { items: [{ id: Number(variant), quantity: 1 }] },
      button,
      name: article.querySelector('h3')?.textContent,
      meta: size ? `${size}` : '',
      image: article.querySelector('.shop-card-image img')?.currentSrc
    }).then(() => {
      button.classList.remove('is-busy');
      button.classList.add('is-added');
      label.textContent = strings.added || label.textContent;
      setTimeout(reset, reduce.matches ? 1200 : 1800);
    }).catch(reset);
  };
  document.addEventListener('click', event => {
    const add = event.target.closest('button.shop-card-add');
    const size = event.target.closest('.shop-card-sizes [data-size]');
    const close = event.target.closest('.shop-card-sizes-close');
    if (add) {
      const article = add.closest('.shop-card');
      if (add.dataset.variant) addToCart(article, add.dataset.variant);
      else if (article.querySelector('.shop-card-sizes')) article.classList.contains('is-choosing') ? closeSheet(article, true) : openSheet(article);
    } else if (size) {
      addToCart(size.closest('.shop-card'), size.dataset.variant, size.dataset.size);
    } else if (close) {
      closeSheet(close.closest('.shop-card'), true);
    } else if (!event.target.closest('.shop-card-sizes')) {
      document.querySelectorAll('.shop-card.is-choosing').forEach(article => closeSheet(article));
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.shop-card.is-choosing');
    if (open) closeSheet(open, true);
  });

  // Pack finder on the home page: all cards are rendered once, tabs and the availability switch filter them.
  document.querySelectorAll('.pack-finder[data-client-filter]').forEach(finder => {
    const cards = [...finder.querySelectorAll('.pack-finder-grid .shop-card')];
    const tabs = [...finder.querySelectorAll('[data-filter]')];
    const onlyAvailable = finder.querySelector('.pack-finder-available input');
    const more = finder.querySelector('.pack-finder-more');
    const empty = finder.querySelector('.pack-finder-empty');
    const step = Number(finder.dataset.step) || 8;
    let filter = 'all';
    let limit = step;
    const matches = (card, key) => key === 'all' || card.dataset.collections.split(' ').includes(key);
    const availableOnly = () => !onlyAvailable || onlyAvailable.checked;
    tabs.forEach(tab => {
      const count = cards.filter(card => matches(card, tab.dataset.filter) && (!availableOnly() || card.dataset.available === 'true')).length;
      const small = tab.querySelector('small');
      if (small) small.textContent = String(count);
      if (!count && tab.dataset.filter !== 'all' && !onlyAvailable) tab.hidden = true;
    });
    const render = () => {
      const list = cards.filter(card => matches(card, filter) && (!availableOnly() || card.dataset.available === 'true'));
      cards.forEach(card => { card.hidden = true; });
      list.slice(0, limit).forEach((card, i) => { card.hidden = false; card.style.setProperty('--i', Math.min(i % step, 6)); });
      const rest = list.length - limit;
      if (more) {
        more.hidden = rest <= 0;
        const next = Math.min(rest, step);
        more.querySelector('span').textContent = next === 1 ? more.dataset.one : more.dataset.many.replace('[count]', next);
      }
      if (empty) empty.hidden = list.length > 0;
    };
    tabs.forEach(tab => tab.addEventListener('click', () => {
      filter = tab.dataset.filter;
      limit = step;
      tabs.forEach(other => other.setAttribute('aria-pressed', String(other === tab)));
      render();
    }));
    onlyAvailable?.addEventListener('change', () => { limit = step; render(); });
    more?.addEventListener('click', () => { limit += step; render(); });
    finder.querySelector('.pack-finder-reset')?.addEventListener('click', () => { if (onlyAvailable) onlyAvailable.checked = false; render(); });
    render();
  });

  // Restock card (home page): rises bottom right after 5 s while the hero is on screen; closing or buying
  // keeps it away for the rest of the visit.
  const pop = document.querySelector('.restock-pop[data-pop]');
  if (pop && document.body.hasAttribute('data-restock-alert')) {
    const storage = {
      get: key => { try { return sessionStorage.getItem(key); } catch { return null; } },
      set: (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* storage blocked */ } }
    };
    if (storage.get('mp-restock-closed')) return pop.remove();
    document.body.append(pop);
    const add = pop.querySelector('.restock-pop-add');
    const sizes = pop.querySelector('.restock-pop-sizes');
    const hero = document.querySelector('main .hero');
    const phone = matchMedia('(max-width: 700px)');
    let ready = false;
    let done = false;
    const inHero = () => {
      if (!hero) return true;
      const bottom = hero.getBoundingClientRect().bottom;
      return phone.matches ? bottom < innerHeight * 0.2 && bottom > -innerHeight * 2.5 : bottom > innerHeight * 0.4;
    };
    const sync = () => {
      const show = ready && !done && inHero() && !document.body.classList.contains('cart-open');
      if (pop.classList.contains('is-visible') === show) return;
      pop.classList.toggle('is-visible', show);
      pop.inert = !show;
      if (!show && sizes && !sizes.hidden) { sizes.hidden = true; add.setAttribute('aria-expanded', 'false'); }
    };
    let queued = false;
    addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }, { passive: true });
    pop.querySelector('.restock-pop-close').addEventListener('click', () => { storage.set('mp-restock-closed', '1'); done = true; sync(); });
    const buy = (variant, size) => {
      if (sizes) sizes.hidden = true;
      add.disabled = true;
      window.mpCart.addWithFeedback({
        payload: { items: [{ id: Number(variant), quantity: 1 }] },
        button: add,
        name: pop.querySelector('strong')?.textContent,
        meta: size || '',
        image: pop.querySelector('.restock-pop-image img')?.currentSrc
      }).then(() => {
        add.classList.add('is-added');
        add.querySelector('span').textContent = strings.added || '✓';
        storage.set('mp-restock-closed', '1');
        setTimeout(() => { done = true; sync(); }, 1800);
      }).finally(() => { add.disabled = false; });
    };
    add.addEventListener('click', () => {
      if (!sizes) return buy(add.dataset.variant);
      sizes.hidden = !sizes.hidden;
      add.setAttribute('aria-expanded', String(!sizes.hidden));
      if (!sizes.hidden) sizes.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
    });
    sizes?.addEventListener('click', event => {
      const chip = event.target.closest('[data-variant]');
      if (chip) buy(chip.dataset.variant, chip.dataset.size);
    });
    setTimeout(() => { ready = true; sync(); }, 5000);
  }
})();
